import {createLazyFileRoute} from '@tanstack/react-router'

import Pricing from '@/views/Pricing/Pricing'

export const Route = createLazyFileRoute('/pricing')({
  component: () => <Pricing />,
})
